const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async updateServiceItemStatus({ rootState }, params = {}) {
      const data = await rootState.http("/service/item/updateServiceItemStatus", params);
      return data;
    },
    async getServiceItemList({ rootState }, params = {}) {
      const data = await rootState.http("service/item/queryServiceItemList", params);
      return data;
    },
    async createServiceItem({ rootState }, params = {}) {
      const data = await rootState.http("/service/item/createServiceItem", params);
      return data;
    },
    async getServiceDetail({ rootState }, params = {}) {
      const data = await rootState.http("/service/item/getServiceItem", params);
      return data;
    },
    async updateService({ rootState }, params = {}) {
      const data = await rootState.http("/service/item/updateServiceItem", params);
      return data;
    },
    async queryTwoLevelClassList({ rootState }, params = {}) {
      const data = await rootState.http("/service/item/queryCodeByLikeName", params);
      return data;
    }
  }
};

export default store;
